import styled, {createGlobalStyle} from 'styled-components';
import {dFlexColumn, alignCenter} from '../../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../../globalVariables/GlobalVariables';
import zIndex from '../../../../../globalVariables/zIndex';

/*
 * Scoped workaround: @tickchak/react-share Tooltip (used by Helper) is portaled
 * to <body> with a hardcoded z-index:1000, identical to Popup
 * (zIndex.basicModal === 1000), so the tooltip renders behind the popup.
 * Because the tooltip lives outside this component's DOM subtree, we lift it
 * via createGlobalStyle that is mounted ONLY while AdvancedTab is rendered,
 * so the rule is not active app-wide. Remove once fixed in the library.
 */
export const HelperTooltipFix = createGlobalStyle`
    [role="tooltip"] {
        z-index: ${zIndex.highestModal};
    }
`;

export const fieldsTwoCols = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--space-lg) var(--space-xl);
    width: 100%;

    ${mobileMedia} {
        grid-template-columns: 1fr;
    }
`;

export const mandatoryBox = styled.section`
    background: var(--TA-color-bg-surface-default);
    border-radius: var(--radius-md);
    padding: var(--space-lg);
    display: flex;
    ${alignCenter};
    gap: var(--space-xl);

    ${mobileMedia} {
        gap: var(--space-lg);
    }
`;

export const mandatoryControls = styled.div`
    display: flex;
    ${alignCenter};
    gap: var(--space-sm);
    flex-shrink: 0;
`;

export const mandatoryText = styled.div`
    ${dFlexColumn};
    gap: var(--space-xs);
    flex: 1;
    min-width: 0;
`;

export const mandatoryTitle = styled.h3`
    margin: 0;
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-body);
    line-height: var(--line-height-body);
    color: var(--TA-color-text-default);
    text-align: start;
`;

export const mandatorySubtitle = styled.p`
    margin: 0;
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-caption);
    line-height: var(--line-height-caption);
    color: var(--TA-color-text-default);
    text-align: start;
`;
